import { Employment, EmploymentStatusEnum } from '../../models/employment';
import { EmploymentInviteeStatusEnum } from '../../models/employmentInviteeStatusEnum';
import { PoolerUser } from '../../models/user';

export function getPoolerEmploymentsNewTabQuery(
  user: PoolerUser,
): Mongo.Selector<Employment> {
  return {
    status: {
      $in: [
        EmploymentStatusEnum.OPEN,
        EmploymentStatusEnum.CLOSED,
        EmploymentStatusEnum.CANCELED,
      ],
    },
    invitees: {
      $elemMatch: {
        userId: user._id,
        hiddenForPooler: { $ne: true },
        status: EmploymentInviteeStatusEnum.OPEN,
      },
    },
  };
}
